import moment from "moment";

// eslint-disable-next-line import/no-anonymous-default-export
export default (filters = {}) => {
  let formateFilters = {};

  if (filters.centers && filters.centers.length > 0) {
    formateFilters.center = [];
    filters.centers.forEach((el) => {
      formateFilters.center.push(el.value);
    });
  }

  if (filters.centerSites && filters.centerSites.length > 0) {
    formateFilters.centerSite = [];
    filters.centerSites.forEach((el) => {
      formateFilters.centerSite.push(el.value);
    });
  }

  if (filters.bloodGroups && filters.bloodGroups.length > 0) {
    formateFilters.bloodGroup = [];
    filters.bloodGroups.forEach((el) => {
      formateFilters.bloodGroup.push(el.value);
    });
  }

  if (filters.startDate) {
    formateFilters.startDate = moment(filters.startDate)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm");
  }

  if (filters.endDate) {
    formateFilters.endDate = moment(filters.endDate)
      .endOf("day")
      .format("YYYY-MM-DD HH:mm");
  }

  // Passed through exactly as given, unlike startDate/endDate above. These
  // bound expiredDate, and "Closer to expiry" needs its lower bound to be the
  // current timestamp: flooring it to midnight would let a unit that expired
  // earlier today read as still usable.
  if (filters.startExpiredDate) {
    formateFilters.startExpiredDate = filters.startExpiredDate;
  }

  if (filters.endExpiredDate) {
    formateFilters.endExpiredDate = filters.endExpiredDate;
  }

  if (filters.donation) {
    formateFilters.donation = filters.donation;
  }

  if (filters.bloodGroup) {
    formateFilters.bloodGroup = filters.bloodGroup;
  }

  if (filters.bloodGroups && Array.isArray(filters.bloodGroups)) {
    formateFilters.bloodGroup = filters.bloodGroups.map((el) => el.value);
  }

  if (filters.receivedBy) {
    formateFilters.receivedBy = filters.receivedBy;
  }

  if (filters.q) {
    formateFilters.q = filters.q;
  }

  if (filters.id) {
    formateFilters.id = filters.id;
  }

  if (filters.donor) {
    formateFilters.donor = filters.donor;
  }

  if (filters.donation) {
    formateFilters.donation = filters.donation;
  }

  if (filters.tested) {
    formateFilters.tested = filters.tested;
  }

  if (filters.q) {
    formateFilters.q = filters.q;
  }

  if (filters.category) {
    formateFilters.category = filters.category;
  }

  if (filters.status) {
    formateFilters.status = filters.status;
  }

  if (filters.productTypes && Array.isArray(filters.productTypes)) {
    formateFilters.productType = filters.productTypes.map((el) => el.value);
  }

  if (filters.page) {
    formateFilters.page = filters.page;
  }

  if (filters.limit) {
    formateFilters.limit = filters.limit;
  }

  if (filters.donationNumber) {
    formateFilters.donationNumber = filters.donationNumber;
  }

  if (filters.donation) {
    formateFilters.donation = filters.donation;
  }

  if (filters["shipmentInfo.status"]) {
    formateFilters["shipmentInfo.status"] = filters["shipmentInfo.status"];
  }

  if (filters.bloodBank) {
    formateFilters.bloodBank = filters.bloodBank?.value || filters.bloodBank;
  }

  // This function is an allowlist: it builds a fresh object and copies only
  // the keys it knows, so anything missing here is dropped before it ever
  // reaches the API. The expiry flags were missing, which is why the Virtual
  // Stock tab listed every unit in the stock rather than the expired ones,
  // and why the Inventory tab kept showing units that had expired. Card
  // clicks were unaffected because they call getData directly and never pass
  // through here.
  if (filters.onlyExpired) {
    formateFilters.onlyExpired = filters.onlyExpired;
  }

  // Stock scope. These reach fetchInventories raw when a card calls getData
  // directly, but a screen whose base filters carry them goes through here
  // first - and anything this allowlist does not name is dropped in silence.
  if (filters.inventoryStatus) {
    formateFilters.inventoryStatus = filters.inventoryStatus;
  }

  if (filters.excludeIncomingReception) {
    formateFilters.excludeIncomingReception = filters.excludeIncomingReception;
  }

  if (filters.onlyNotExpired) {
    formateFilters.onlyNotExpired = filters.onlyNotExpired;
  }

  return formateFilters;
};
